import { PurchaseOfferSortingInput, PurchaseOfferStatusEnum } from '../../../../shared/graphql-types';

export class OffersLookupCriteria {
  status = [PurchaseOfferStatusEnum.Active, PurchaseOfferStatusEnum.Bid, PurchaseOfferStatusEnum.BidApproved];
  sorting: PurchaseOfferSortingInput = {legs: {departureTimeUTC: true}};
  airportCode: string  = null;
  skip: number = 0;
  limit: number = 20;
  total: number = 0;
}
